module.exports = __webpack_public_path__ + "static/img/storageBottom4.732335f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/storageBottom4.png
// module id = IagT
// module chunks = 2